import { render, staticRenderFns } from "./MainIdentificacion.vue?vue&type=template&id=c8dc573a"
import script from "./MainIdentificacion.vue?vue&type=script&lang=js"
export * from "./MainIdentificacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports